module.exports = __webpack_public_path__ + "img/正方形logo.9a5ebb23.png";